import React from 'react';
import {
  EVBox,
  EVGrid,
  EVTypography,
} from '@eagleview/ev-comp-library';
import CheckCircle from '../../assets/images/check_circle_outline.svg';
import LinkIcon from '../../assets/images/link_24px.svg';
import useStyles from './ActivatedStyle';
import evLogo from '../../assets/images/evLogo.svg';
import PartnerContinueButton from './PartnerContinueButton.component';

const Activated = () => {
  const classes = useStyles();

  const searchParams = new URLSearchParams(window.location.search);
  const partnerName = searchParams.get('partner_name');

  return (
    <EVBox wrap="nowrap" className={classes.topContainer}>
      <EVGrid
        container
        wrap="nowrap"
        style={{
          flexDirection: 'row',
          height: '100%',
          position: 'relative',
        }}
      >
        <EVGrid style={{
          flexGrow: 1,
          position: 'static',
          backgroundRepeat: 'no-repeat',
          backgroundImage: 'url(/assets/images/evbackground.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: '50%',
        }}
        />
        <EVGrid className={classes.formMainContainer}>
          <EVGrid className={classes.evLogoContainer}>
            <img
              src={evLogo}
              alt="EagleView"
              className={classes.logo}
            />
          </EVGrid>
          <EVGrid className={classes.formContainer}>
            <EVGrid container justifyContent="center" style={{ gap: '16px' }}>
              <EVBox className={classes.stepBox}>
                <EVBox style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <EVBox style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                    <img src={CheckCircle} alt="" className={classes.img} style={{ padding: '4px' }} />
                    <EVBox className={classes.headerContainer}>
                      <EVTypography className={classes.stepHeader}>Step 1:</EVTypography>
                      <EVTypography className={classes.descHeader}>Account Activated</EVTypography>
                    </EVBox>
                  </EVBox>
                  <EVBox style={{ padding: '0px 24px 0px 56px' }}>
                    <EVTypography className={classes.text}>Your Eagleview account is active.</EVTypography>
                  </EVBox>
                </EVBox>
              </EVBox>
              <EVBox className={classes.stepBox}>
                <EVBox style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <EVBox style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                    <img src={LinkIcon} alt="" className={classes.img} style={{ padding: '14px 4px' }} />
                    <EVBox className={classes.headerContainer}>
                      <EVTypography className={classes.stepHeader}>Step 2:</EVTypography>
                      <EVTypography className={classes.descHeader}>Link Your Accounts</EVTypography>
                    </EVBox>
                  </EVBox>
                  <EVBox style={{ padding: '0px 24px 0px 56px' }}>
                    <EVTypography className={classes.text}>
                      To complete the authorization process, return to
                      {' '}
                      <span className={classes.emailText}>{partnerName}</span>
                      &apos;s site to link your accounts.
                    </EVTypography>
                  </EVBox>
                </EVBox>
                <EVBox className={classes.partnerUrlButtonContainer}>
                  <PartnerContinueButton
                    id="partnerUrl"
                    className={classes.partnerUrlButton}
                  />
                </EVBox>
              </EVBox>
            </EVGrid>
          </EVGrid>
        </EVGrid>
      </EVGrid>
    </EVBox>
  );
};

export default Activated;
